var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndrawPlaylistLibraby(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 880,
    height: 710.16,
    viewBox: "0 0 880 710.16",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_91",
    "data-name": "Group 91",
    transform: "translate(-520 -184.92)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_461-635",
    "data-name": "Path 461",
    d: "M926.4,695.082a31.2,31.2,0,0,1-30.127-5.307c-10.552-8.857-13.864-23.447-16.552-36.959l-7.962-39.963,16.669,11.479c11.988,8.254,24.245,16.773,32.546,28.73s11.923,28.278,5.255,41.215",
    transform: "translate(137.738 150.699)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_462-636",
    "data-name": "Path 462",
    d: "M897.159,729.68c1.687-12.29,3.422-24.737,2.239-37.158-1.052-11.031-4.416-21.806-11.269-30.64a50.967,50.967,0,0,0-13.078-11.851c-1.308-.824-2.511,1.248-1.209,2.069a48.458,48.458,0,0,1,19.167,23.126c4.173,10.614,4.843,22.184,4.118,33.459-.435,6.818-1.356,13.59-2.286,20.358a1.235,1.235,0,0,0,.837,1.474,1.205,1.205,0,0,0,1.474-.837Z",
    transform: "translate(165.557 164.484)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_482-637",
    "data-name": "Path 482",
    d: "M1006.26,728.119s17.506-43.091-35.011-75.409Z",
    transform: "translate(-78.197 165.554)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_483-638",
    "data-name": "Path 483",
    d: "M923.6,715.341s5.34-30.713,46.673-30.45Z",
    transform: "translate(25.987 177.548)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1413-639",
    "data-name": "Path 1413",
    d: "M252.9,506.071H637.753V234.6H252.9Z",
    transform: "translate(338.061 9.715)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1414-640",
    "data-name": "Path 1414",
    d: "M648.225,516.543H246.9V228.6H648.225Zm-393.09-8.236H639.989V236.835H255.136Z",
    transform: "translate(335.824 7.479)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1415-641",
    "data-name": "Path 1415",
    d: "M27.648,297.767H24.811V21.869H409.675v2.859H27.648Z",
    transform: "translate(529.247 193.071)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1416-642",
    "data-name": "Path 1416",
    d: "M2.839,275.9H0V0H384.864V2.859H2.839Z",
    transform: "translate(520 184.92)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1438-643",
    "data-name": "Path 1438",
    d: "M1132.863,709.414H609.856a1.373,1.373,0,1,1,0-2.745h523.007a1.373,1.373,0,0,1,0,2.745Z",
    transform: "translate(265.765 185.666)",
    fill: "#cbcbcb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87",
    "data-name": "Group 87",
    transform: "translate(1096.31 281.882)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_276",
    "data-name": "Ellipse 276",
    cx: 14.775,
    cy: 14.775,
    r: 14.775,
    transform: "translate(114.921 3.365)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1439-644",
    "data-name": "Path 1439",
    d: "M767.961,236.036a14.777,14.777,0,0,1,9.549-23.509,14.772,14.772,0,1,0,1.837,29.366,14.738,14.738,0,0,1-11.385-5.857Z",
    transform: "translate(-652.212 -212.521)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_277",
    "data-name": "Ellipse 277",
    cx: 43.402,
    cy: 43.402,
    r: 43.402,
    transform: "translate(70.988 27.02)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1440-645",
    "data-name": "Path 1440",
    d: "M734.336,261.77a43.394,43.394,0,0,1,56.2-21.914c-.438-.219-.873-.442-1.322-.648A43.4,43.4,0,0,0,753,318.1c.448.206.9.391,1.353.58a43.394,43.394,0,0,1-20.012-56.905Z",
    transform: "translate(-660.388 -207.158)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1441-646",
    "data-name": "Path 1441",
    d: "M656.9,231.561l-14.7,11.023-7.348-22.046,16.535-5.512Z",
    transform: "translate(-488.306 23.723)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1442-647",
    "data-name": "Path 1442",
    d: "M671.965,256.953l29.394,152.483,38.581,113.9L677.477,536.2,616.851,308.392l-1.838,218.621-79,1.837,18.371-130.437,9.186-146.971Z",
    transform: "translate(-511.636 32.318)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1443-648",
    "data-name": "Path 1443",
    d: "M727.546,662.419v29.394l-1.837,16.534s-3.674,14.7,18.371,11.023S755.1,699.161,755.1,699.161l-7.349-14.7-3.674-23.883Z",
    transform: "translate(-660.911 -106.762)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1444-649",
    "data-name": "Path 1444",
    d: "M843,660.377l5.3,28.913,4.788,15.932s6.264,13.794-16.083,14.154-14.486-17.89-14.486-17.89L827.1,685.7l-.692-24.154Z",
    transform: "translate(-638.322 -106.81)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_278",
    "data-name": "Ellipse 278",
    cx: 27.557,
    cy: 27.557,
    r: 27.557,
    transform: "translate(86.843 55.954)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1445-650",
    "data-name": "Path 1445",
    d: "M755.116,293.813s3.674,29.394-11.023,36.743,27.557,18.371,27.557,18.371l25.72-29.394s-12.86-16.534-9.186-27.557Z",
    transform: "translate(-657.25 -193.767)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1446-651",
    "data-name": "Path 1446",
    d: "M801.523,309.811s-3.674,18.371-25.72,18.371S759.269,319,759.269,319l-29.394,14.7,3.674,84.508-25.72,62.463s14.7-3.674,33.069,5.511,53.277,1.837,53.277,1.837,14.7-1.837,23.883,1.837S829.08,482.5,829.08,482.5l-11.023-53.277,16.534-58.789L830.917,319Z",
    transform: "translate(-665.077 -189.557)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1447-652",
    "data-name": "Path 1447",
    d: "M702.039,458.443l-5.511,23.883s-20.209,34.906-5.511,36.743,18.371-36.743,18.371-36.743l9.186-23.883Z",
    transform: "translate(-670.311 -154.474)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1448-653",
    "data-name": "Path 1448",
    d: "M795.522,323.114l9.038-7.4,5.659,1.886s9.186-1.837,18.371,12.86,45.107,61.873,44.091,69.811-49.6,40.417-49.6,40.417,1.837,5.512,0,7.349-12.86,5.511-12.86,3.674-12.476-25.247-12.476-25.247,8.8-11.5,10.639-9.658a73.238,73.238,0,0,0,7.349,5.512l14.7-14.7a26.867,26.867,0,0,0,3.674-5.512c2.4-4.289,1.837-11.023-31.231-42.254Z",
    transform: "translate(-644.378 -188.163)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1449-654",
    "data-name": "Path 1449",
    d: "M742.609,329.6l-4.945-2.423s-11.589,2.423-15.263,9.772-12.86,82.671-12.86,82.671l-7.349,49.6s-5.511,0-5.511,5.511-7.349,20.209-1.837,20.209,27.557,0,31.231-3.674,11.023-18.371,9.186-20.209-5.511-1.837-5.511-1.837l11.023-51.44Z",
    transform: "translate(-668.626 -185.459)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1450-655",
    "data-name": "Path 1450",
    d: "M588.266,66.122V96.8h7.106l9.043-9.689L603.2,96.8h31.409l-1.937-9.689,3.875,9.689h5.006V66.122Z",
    transform: "translate(-499.303 -11.424)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1451-656",
    "data-name": "Path 1451",
    d: "M631.157,83.024h3.729a7.922,7.922,0,0,1,7.922,7.922v.866a7.922,7.922,0,0,1-7.922,7.922h-3.729Z",
    transform: "translate(-489.18 -7.435)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1452-657",
    "data-name": "Path 1452",
    d: "M630.413,80.791h3.373a3.373,3.373,0,0,1,3.372,3.373V99.647a3.373,3.373,0,0,1-3.372,3.373h-3.373Z",
    transform: "translate(-489.355 -7.962)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1453-658",
    "data-name": "Path 1453",
    d: "M0,0H3.729a7.922,7.922,0,0,1,7.922,7.922v.866a7.922,7.922,0,0,1-7.922,7.922H0Z",
    transform: "translate(86.824 92.298) rotate(180)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1454-659",
    "data-name": "Path 1454",
    d: "M0,0H3.373A3.373,3.373,0,0,1,6.745,3.373V18.856a3.373,3.373,0,0,1-3.373,3.373H0Z",
    transform: "translate(87.743 95.057) rotate(180)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1455-660",
    "data-name": "Path 1455",
    d: "M803.289,281.135h-2.472c0-17.459-12.936-31.663-28.837-31.663s-28.838,14.2-28.838,31.663H740.67c0-18.822,14.045-34.135,31.31-34.135S803.289,262.313,803.289,281.135Z",
    transform: "translate(-657.326 -204.383)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1456-661",
    "data-name": "Path 1456",
    d: "M697.363,473.991l-.217.138-3.775-5.95a4.078,4.078,0,0,0-5.629-1.259l-12.607,8a4.079,4.079,0,0,0-1.259,5.629l20.711,32.645a4.079,4.079,0,0,0,5.629,1.259l12.607-8a4.079,4.079,0,0,0,1.259-5.629l-14.249-22.459.217-.138Z",
    transform: "translate(-673.241 -152.623)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1457-662",
    "data-name": "Path 1457",
    d: "M692.438,468.482l20.681,32.6a3.046,3.046,0,0,1-.94,4.2l-12.667,8.037a3.046,3.046,0,0,1-4.2-.94l-20.681-32.6a3.046,3.046,0,0,1,.94-4.2l1.537-.975a1.448,1.448,0,0,0,2.2.966l7.222-4.582a1.448,1.448,0,0,0,.063-2.4l1.645-1.044A3.046,3.046,0,0,1,692.438,468.482Z",
    transform: "translate(-673.026 -152.438)",
    fill: "#6c63ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_90",
    "data-name": "Group 90",
    transform: "translate(0 6.447)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    "data-name": "Group 89"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1417-663",
    "data-name": "Path 1417",
    d: "M393.013,394.748c-33.577,0-60.894-27.514-60.894-61.334s27.317-61.334,60.894-61.334,60.894,27.514,60.894,61.334S426.59,394.748,393.013,394.748Zm0-120.671c-32.476,0-58.9,26.618-58.9,59.336s26.421,59.336,58.9,59.336,58.9-26.618,58.9-59.336S425.489,274.078,393.013,274.078Z",
    transform: "translate(391.2 -9.712)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1418-664",
    "data-name": "Path 1418",
    d: "M175.3,112.182v60.909L225,142.22Z",
    transform: "translate(592.358 181.586)",
    fill: "#6c63ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_88",
    "data-name": "Group 88",
    transform: "translate(0.001 -155.092)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1476-665",
    "data-name": "Path 1476",
    d: "M951.757,412.759H714.427a1.835,1.835,0,1,1,0-3.67h237.33a1.835,1.835,0,1,1,0,3.67Z",
    transform: "translate(-49.707 173.94)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1479-666",
    "data-name": "Path 1479",
    d: "M748.468,465.664a1,1,0,0,1-1-1v-18a1,1,0,0,1,2,0v18a1,1,0,0,1-1,1Z",
    transform: "translate(-49.707 173.94)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1480-667",
    "data-name": "Path 1480",
    d: "M829.968,465.664a1,1,0,0,1-1-1v-18a1,1,0,0,1,2,0v18a1,1,0,0,1-1,1Z",
    transform: "translate(-49.707 173.94)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1481-668",
    "data-name": "Path 1481",
    d: "M836.968,465.664a1,1,0,0,1-1-1v-18a1,1,0,0,1,2,0v18a1,1,0,0,1-1,1Z",
    transform: "translate(-49.707 173.94)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1482-669",
    "data-name": "Path 1482",
    d: "M763.148,465.989a2.313,2.313,0,0,1-1.16-.315l-11.894-8.022-.067-.042a2.267,2.267,0,0,1-1.059-1.948,2.3,2.3,0,0,1,1.16-2.009l11.8-7.965a2.319,2.319,0,0,1,3.539,1.972v16a2.329,2.329,0,0,1-2.32,2.324Zm-.1-2.01a.306.306,0,0,0,.26-.037.311.311,0,0,0,.16-.277v-16a.32.32,0,0,0-.48-.277l-11.8,7.965c-.2.117-.219.245-.219.314a.31.31,0,0,0,.16.277l.06.037Z",
    transform: "translate(-49.707 173.94)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1483-670",
    "data-name": "Path 1483",
    d: "M916.468,465.664a1,1,0,0,1-1-1v-18a1,1,0,0,1,2,0v18a1,1,0,0,1-1,1Z",
    transform: "translate(-49.707 173.94)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1484-671",
    "data-name": "Path 1484",
    d: "M901.77,465.985a2.272,2.272,0,0,1-1.141-.31,2.3,2.3,0,0,1-1.16-2.009v-16a2.32,2.32,0,0,1,3.48-2.009l11.919,8.039a2.262,2.262,0,0,1,1.1,1.972,2.3,2.3,0,0,1-1.126,1.989l-11.835,7.985a2.458,2.458,0,0,1-1.238.347Zm-.3-2.319a.32.32,0,0,0,.48.277l11.846-7.994a.337.337,0,0,0,.174-.284h0a.309.309,0,0,0-.16-.277l-11.92-8.039a.3.3,0,0,0-.261.037.31.31,0,0,0-.16.277Z",
    transform: "translate(-49.707 173.94)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_281",
    "data-name": "Ellipse 281",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(718.761 572.864)",
    fill: "#090814"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawPlaylistLibraby);
export default __webpack_public_path__ + "static/media/undraw_playlist_libraby.737c3e32acf2ce0b690b318fc85591d1.svg";
export { ForwardRef as ReactComponent };